const accessibilityInformation = {
    'title': 'accessibilityInformation.title',
    'list': [
        {
            'content': 'accessibilityInformation.list[0].content',
        },
        {
            'content': 'accessibilityInformation.list[1].content',
        },
        {
            'content': 'accessibilityInformation.list[2].content',
        },
        {
            'content': 'accessibilityInformation.list[3].content',
        },
        {
            'content': 'accessibilityInformation.list[4].content',
        },
        {
            'content': 'accessibilityInformation.list[5].content',
        },
        {
            'content': 'accessibilityInformation.list[6].content',
        },
        {
            'content': 'accessibilityInformation.list[7].content',
        },
        {
            'content': 'accessibilityInformation.list[8].content',
        },
        {
            'content': 'accessibilityInformation.list[9].content',
        },
        {
            'content': 'accessibilityInformation.list[10].content',
        },
        {
            'content': 'accessibilityInformation.list[11].content',
        },
    ],
}

export default accessibilityInformation
